
import { TransferAssetApproverMetadataBase } from './transfer-asset-approver.metadata.base';


export class TransferAssetApproverMetadata extends TransferAssetApproverMetadataBase {
  constructor() {
    super();
  }
}

export const TRANSFER_ASSET_APPROVER_METADATA: TransferAssetApproverMetadata = new TransferAssetApproverMetadata();


